import { connect } from 'react-redux';
import PopUpMenu from './popupmenu';
import {
  startNewRoutePlanning, finishRoutePlanning, editRoutePlanning, openRouteDialog, openArticlelistDialog, openReportDialog,
  downloadLabels,
  printAllLabels,
} from '../../reducers/order.reducers';
import { openSettingsDialog } from '../../reducers/app.reducers';
import { toggleProductDialog } from '../../reducers/menu.reducers';

const mapStateToProps = state => ({
  isRoutePlanning: state.orders.routeplanning,
  localSettings: state.app.localSettings,
});

const mapDispatchToProps = dispatch => ({
  startNewRoutePlanning: () => dispatch(startNewRoutePlanning()),
  editRoutePlanning: () => dispatch(editRoutePlanning()),
  finishRoutePlanning: () => dispatch(finishRoutePlanning()),
  openRouteDialog: () => dispatch(openRouteDialog()),
  openArticleListDialog: () => dispatch(openArticlelistDialog()),
  toggleProductDialog: productDialogOpen => dispatch(toggleProductDialog(productDialogOpen)),
  openSettingsDialog: () => dispatch(openSettingsDialog()),
  openReportDialog: () => dispatch(openReportDialog()),
  downloadLabels: () => dispatch(downloadLabels()),
  printLabels: () => dispatch(printAllLabels())
});

export default connect(mapStateToProps, mapDispatchToProps)(PopUpMenu);
